import { FileDropzoneMultiple } from '../../../../shared/FormElements/FileInputs/FileDropzone';
import WarrantyFormMessage from '../Fields/WarrantyFormMessage';

const SAMPLE_PHOTOS = [
  {
    src: 'https://cdn.retainerclub.com/images/warranties/samples/03_aligner_issue.webp',
    caption: 'Affected area',
  },
  {
    src: 'https://cdn.retainerclub.com/images/warranties/samples/02_aligners_pair.webp',
    caption: 'Full arch',
  },
  {
    src: 'https://cdn.retainerclub.com/images/warranties/samples/01_code_closeup.webp',
    caption: 'Retainer ID / laser marking',
  },
];

function StepThree() {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="font-bold text-gray-900 text-xl leading-6">
          Additional Information
        </h3>
        <p className="mt-1 text-gray-500 text-sm">
          Help us understand the issue better
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 text-left sm:grid-cols-1">
        {/* Photo guidance + sample images */}
        <div>
          <p className="text-gray-700 text-sm">
            Please attach clear photos showing the affected area, full arch, and
            retainer ID/laser marking on the retainer(s).
          </p>
          <div className="mt-3 grid grid-cols-3 gap-3">
            {SAMPLE_PHOTOS.map((photo) => (
              <figure key={photo.src}>
                <img
                  alt={`Example: ${photo.caption}`}
                  className="aspect-[4/3] w-full rounded-md object-cover ring-1 ring-gray-200"
                  loading="lazy"
                  src={photo.src}
                />
                <figcaption className="mt-1 text-center text-gray-500 text-xs">
                  {photo.caption}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        {/* Warranty Images Upload */}
        <FileDropzoneMultiple
          name="warrantyImagesAttributes"
          label="Upload images"
          maxFiles={5}
          required
          storagePath="images/warranties"
        />

        {/* Additional Details Text Area */}
        <WarrantyFormMessage />
      </div>
    </div>
  );
}

export default StepThree;
